"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FieldType = exports.transFuncs = exports.fileDomain = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _moment = _interopRequireDefault(require("moment"));

var _vueJsonView = require("vue-json-view");

var _filterType = require("./filterType");

var _utils = require("../utils");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var getDataByName = _vueJsonView.Utils.getDataByName,
    setDataByObj = _vueJsonView.Utils.setDataByObj;
var fileDomain = 'https://file-scrm.dipont.com';
exports.fileDomain = fileDomain;

function isObjectArray(type) {
  return (0, _typeof2.default)(type) === 'object' && (type.type === 'array' && (0, _typeof2.default)(type.items) === 'object' && type.items.type === 'object' || type.type === 'objectArray');
}
/**
 * 存储所有类型的转化方法， 可参考 antd table columns 属性
 * customRender: 将原始数据转化为在表格中展示的数据
 * reverseRender: 将在表格中展示的数据转化为原始数据
 */


var transFuncs = {
  'boolean': function boolean(config) {
    return {
      customRender: function customRender(text) {
        return text ? '是' : '否';
      },
      reverseRender: function reverseRender(text) {
        return text === '是';
      }
    };
  },
  'number': function number(config) {
    return {
      customRender: function customRender(text) {
        return text !== undefined && text !== null ? text + '' : text;
      },
      reverseRender: function reverseRender(text) {
        var _config$children;

        if (!text) {
          return text;
        }

        if (config !== null && config !== void 0 && (_config$children = config.children) !== null && _config$children !== void 0 && _config$children.precision) {
          var _config$children2;

          return Number(Number(text).toFixed(config === null || config === void 0 ? void 0 : (_config$children2 = config.children) === null || _config$children2 === void 0 ? void 0 : _config$children2.precision));
        }

        return Number(text);
      }
    };
  },
  'cascadeLabelValue': function cascadeLabelValue(config) {
    var type = config._type;
    var label = type.labelPath && getDataByName(config, type.labelPath) || 'label';
    var value = type.valuePath && getDataByName(config, type.valuePath) || 'value';
    var parent = type.parentPath && getDataByName(config, type.parentPath) || 'parentId';
    var options = getDataByName(config, type.path);

    if (Array.isArray(options)) {
      options = options.map(function (opt) {
        var _opt$label;

        return (0, _typeof2.default)(opt) === 'object' ? _objectSpread(_objectSpread({}, opt), {}, {
          label: (_opt$label = opt[label]) === null || _opt$label === void 0 ? void 0 : _opt$label.trim(),
          value: opt[value],
          parentId: opt[parent]
        }) : opt;
      });
    } else {
      options = [];
    }

    return {
      customRender: function customRender(text) {
        var result = [];

        while (text && text !== '~') {
          var obj = options.find(function (opt) {
            if ((0, _typeof2.default)(opt) !== 'object') {
              return opt === text;
            }

            return opt.value === text;
          });

          if (obj) {
            result.push((0, _typeof2.default)(obj) === 'object' ? obj.label : obj || text);
          } else {
            result.push(text);
            text = '';
          }

          text = obj === null || obj === void 0 ? void 0 : obj.parentId;
        }

        if (config.showLast) {
          return result[0];
        }

        return result.reverse().join('/');
      },
      reverseRender: function reverseRender(text) {
        var _config$children3;

        text = text && (text + '').trim();
        var treeOptions = (0, _utils.list2Tree)(options);
        var searchOptions = (0, _utils.treeList2Map)(treeOptions);

        if (config !== null && config !== void 0 && (_config$children3 = config.children) !== null && _config$children3 !== void 0 && _config$children3.changeOnSelect) {
          searchOptions.push.apply(searchOptions, (0, _toConsumableArray2.default)(options));
        } else {
          searchOptions.push.apply(searchOptions, (0, _toConsumableArray2.default)((0, _utils.getTreeLastLevel)(treeOptions)));
        }

        var obj = searchOptions.find(function (opt) {
          if ((0, _typeof2.default)(opt) !== 'object') {
            return opt === text;
          }

          return opt.label === text;
        });

        if ((0, _typeof2.default)(obj) !== 'object') {
          return obj || text;
        }

        return obj.value || obj.label;
      }
    };
  },
  'labelValue': function labelValue(config) {
    var type = config._type;
    var label = type.labelPath && getDataByName(config, type.labelPath) || 'label';
    var value = type.valuePath && getDataByName(config, type.valuePath) || 'value';
    var options = getDataByName(config, type.path);

    if (Array.isArray(options)) {
      options = options.map(function (opt) {
        var _opt$label2;

        return (0, _typeof2.default)(opt) === 'object' ? _objectSpread(_objectSpread({}, opt), {}, {
          label: (_opt$label2 = opt[label]) === null || _opt$label2 === void 0 ? void 0 : _opt$label2.trim(),
          value: opt[value]
        }) : opt;
      });
    } else {
      options = [];
    }

    return {
      customRender: function customRender(text) {
        if (text) {
          var obj = options.find(function (opt) {
            if ((0, _typeof2.default)(opt) !== 'object') {
              return opt === text;
            }

            return opt.value === text;
          });

          if ((0, _typeof2.default)(obj) !== 'object') {
            return obj || text;
          }

          return obj.label || obj.value;
        }
      },
      reverseRender: function reverseRender(text) {
        text = text && (text + '').trim();
        var obj = options.find(function (opt) {
          if ((0, _typeof2.default)(opt) !== 'object') {
            return opt === text;
          }

          return opt.label === text;
        });

        if ((0, _typeof2.default)(obj) !== 'object') {
          return obj || text;
        }

        return obj.value || obj.label;
      }
    };
  },
  'searchLabelValue': function searchLabelValue(config) {
    var type = config._type;
    var label = type.labelPath && getDataByName(config, type.labelPath) || 'label';
    return {
      customRender: function customRender(text) {
        return text && text[label];
      }
    };
  },
  'objectArray': function objectArray(config) {
    var type = config._type;

    if ((0, _typeof2.default)(type) === 'object') {
      var items = type.items;

      if (!items) {
        items = getDataByName(config, type.path || '') || [];
      }

      if (!config.label) {
        return trans2TreeByType(items).map(function (item) {
          return _objectSpread(_objectSpread({}, item), {}, {
            dataIndex: config.name + '__' + item.dataIndex,
            // fix: xlsx 导出子表单公式问题
            objectArrayName: config.name
          });
        });
      }

      return {
        children: trans2TreeByType(items).map(function (item) {
          return _objectSpread(_objectSpread({}, item), {}, {
            dataIndex: config.name + '__' + item.dataIndex
          });
        })
      };
    }
  },
  'object': function object(config) {
    var type = config._type;

    if ((0, _typeof2.default)(type) === 'object') {
      var items = type.items;

      if (!items) {
        items = getDataByName(config, type.path || '') || [];
      }

      if (!config.label) {
        return trans2TreeByType(items).map(function (item) {
          return _objectSpread(_objectSpread({}, item), {}, {
            dataIndex: config.name + '.' + item.dataIndex
          });
        });
      }

      return {
        key: config.name,
        dataIndex: undefined,
        children: trans2TreeByType(items)
      };
    }
  },
  'array': function array(config) {
    var type = config._type;

    if ((0, _typeof2.default)(type) !== 'object') {
      return;
    }

    if (type.items && type.items.type === 'object') {
      // 子表单
      return transFuncs['objectArray'](_objectSpread(_objectSpread({}, config), {}, {
        _type: type.items
      }));
    } else {
      var extraCol;

      if ((0, _typeof2.default)(type.items) === 'object') {
        extraCol = transFuncs[type.items.type] && transFuncs[type.items.type](_objectSpread(_objectSpread({}, config), {}, {
          _type: _objectSpread(_objectSpread({}, type.items), {}, {
            labelPath: type.labelPath,
            valuePath: type.valuePath
          })
        }));
      } else {
        extraCol = transFuncs[type.items] && transFuncs[type.items](_objectSpread(_objectSpread({}, config), {}, {
          _type: type.items
        }));
      }

      var func = extraCol && extraCol.customRender;
      var reverseFunc = extraCol && extraCol.reverseRender;
      return {
        customRender: function customRender(text) {
          if (!text) {
            return;
          }

          var temp = text.map(function (t) {
            return func ? func(t) : t;
          });
          var out = [];
          temp.forEach(function (t, i) {
            out.push(t);

            if (i !== temp.length - 1) {
              out.push(', ');
            }
          });
          return out;
        },
        reverseRender: function reverseRender(text) {
          if (!text) {
            return;
          }

          var list = text.split(',');
          return list.map(function (t) {
            return t && (reverseFunc ? reverseFunc(t.trim()) : t.trim());
          });
        }
      };
    }
  },
  'date': function date(config) {
    var type = config._type;
    return {
      customRender: function customRender(text) {
        return text && (0, _moment.default)(text).format(type.format);
      },
      reverseRender: function reverseRender(text) {
        if (!text) {
          return;
        }

        if (typeof text === 'number') {
          return (0, _moment.default)('1900-01-01').add(text - 2, 'd').valueOf();
        }

        return (0, _moment.default)(text).valueOf();
      }
    };
  },
  'file': function file(config) {
    return {
      customRender: function customRender(text) {
        return {
          tag: 'a',
          href: text.type === 'server/img' ? "/".concat(text.url) : "".concat(fileDomain, "/").concat(text.hash).concat(text.type && text.type.includes('image') ? '' : "?attname=".concat(text.name)),
          target: '_blank',
          download: text.type && text.type.includes('image') ? undefined : text.name,
          children: text.name
        };
      }
    };
  },
  'jsonView': function jsonView() {
    return {
      customRender: function customRender(text) {
        return text && JSON.parse(text);
      }
    };
  },
  'spreadArray': function spreadArray(config) {
    var type = config._type;
    var items = type.items;

    if (!items) {
      items = getDataByName(config, type.path || '') || [];
    }

    return trans2TreeByType(items, config.name);
  },
  'interString': function interString(config) {
    var type = config._type;
    return {
      customRender: function customRender() {
        return getDataByName(config, type.path);
      }
    };
  }
};
exports.transFuncs = transFuncs;

function setFileDomain(domain) {
  exports.fileDomain = fileDomain = domain;
}
/**
 * 设置转换方法
 * @param name
 * @param func
 */


function setTransFunc(name, func) {
  transFuncs[name] = func;
}
/**
 * 通过类型把config转换成树形
 * @param configs
 * @param preName
 * @param width
 */


function trans2TreeByType(configs, preName) {
  var columns = [];
  configs.forEach(function (config) {
    var type = config._type;

    if (!type) {
      return;
    }

    var column = {
      title: config.label || undefined,
      dataIndex: preName ? preName + '.' + config.name : config.name,
      width: config._tableWidth
    };
    var extraCol;

    if ((0, _typeof2.default)(type) === 'object') {
      extraCol = transFuncs[type.type] && transFuncs[type.type](config);
    } else {
      extraCol = transFuncs[type] && transFuncs[type](config);
    }

    if (config._text) {
      extraCol = _objectSpread(_objectSpread({}, extraCol || {}), {}, {
        customRender: function customRender() {
          return config._text;
        }
      });
    }

    if (extraCol && Array.isArray(extraCol)) {
      // 如果是 extraCol 是数组
      columns = [].concat((0, _toConsumableArray2.default)(columns), (0, _toConsumableArray2.default)(extraCol));
    } else {
      columns.push(Object.assign(column, extraCol || {}));
    }
  });
  return columns;
}
/**
 * 通过类型把config转成list类型
 * @param configs
 * @param prefixTitle
 * @param prefixDataIndex
 */


function trans2ListByType(configs) {
  var prefixTitle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var prefixDataIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var out = [];
  configs.forEach(function (config) {
    var newTitle = config.label ? [].concat((0, _toConsumableArray2.default)(prefixTitle), [config.label]) : prefixTitle;
    var newName = [].concat((0, _toConsumableArray2.default)(prefixDataIndex), [config.name]);

    if (config._type && isObjectArray(config._type)) {
      var items = getDataByName(config, config._type.path || '') || [];
      out = [].concat((0, _toConsumableArray2.default)(out), (0, _toConsumableArray2.default)(trans2ListByType(items, newTitle, newName)));
    } else if (config._type) {
      out.push(_objectSpread(_objectSpread({}, config), {}, {
        title: newTitle.join('.'),
        dataIndex: newName.join('.')
      }));
    }
  });
  return out;
}
/**
 * 根据类型转换数据
 * 主要解决合并单元格问题
 * @param data
 * @param configs
 */


function transDataByType() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var configs = arguments.length > 1 ? arguments[1] : undefined;
  var arrayObjConfigs = [];
  var out = []; // 寻找所有 objectArray

  configs.forEach(function (config) {
    if (config._type && isObjectArray(config._type)) {
      arrayObjConfigs.push(config);
    }
  });
  data.forEach(function (record) {
    var currentOut = [_objectSpread({}, record)];
    var allRowSpan = 1; // 所有 objectArray 属性单独处理

    arrayObjConfigs.forEach(function (config) {
      // 子表单的数据
      var currentData = getDataByName(record, config.name); // 子表单配置

      var childConfigs = getDataByName(config, config._type.path);
      var currentRowSpan = 0;
      transDataByType(currentData, childConfigs).map(function (cd, i) {
        // 子表单对于行不存在 就添加一行
        if (!currentOut[i]) {
          currentOut[i] = _objectSpread({}, record);
        }

        currentRowSpan += cd.rowSpan || 0;
        Object.keys(cd).forEach(function (key) {
          var _objectSpread2;

          if (key.includes('_rowSpan')) {
            return;
          }

          currentOut[i] = _objectSpread(_objectSpread({}, currentOut[i]), {}, (_objectSpread2 = {}, (0, _defineProperty2.default)(_objectSpread2, config.name + '__' + key, cd[key]), (0, _defineProperty2.default)(_objectSpread2, config.name + '__' + key + '_rowSpan', cd[key + '_rowSpan'] || cd.rowSpan), (0, _defineProperty2.default)(_objectSpread2, "_index", Math.random()), (0, _defineProperty2.default)(_objectSpread2, "_objectArrayIndex", i), (0, _defineProperty2.default)(_objectSpread2, "rowSpan", undefined), _objectSpread2));
        });
      });
      allRowSpan = Math.max(currentRowSpan, allRowSpan);
    });
    currentOut[0].rowSpan = allRowSpan;
    out = [].concat((0, _toConsumableArray2.default)(out), currentOut);
  });
  return out;
}

var FieldType = {
  trans2TreeByType: trans2TreeByType,
  trans2ListByType: trans2ListByType,
  setTransFunc: setTransFunc,
  transDataByType: transDataByType,
  getFilterMethod: _filterType.getFilterMethod,
  setFilterMethod: _filterType.setFilterMethod,
  setFileDomain: setFileDomain
};
exports.FieldType = FieldType;